
import SelectInput from "@/components/Form/SelectInput.vue";
import { computed, defineComponent, toRefs } from "vue";
import { useStore } from "vuex";
import {
  ISelectOption,
  useLocationPackagesSelect
} from "@/hooks/esim/location-packages/modules/useLocationPackagesSelect";

export default defineComponent({
  name: "SelectDataType",
  components: { SelectInput },
  props: {
    selectedDataTypeId: { type: Number, default: -1 }
  },
  emits: { select: null },

  setup(props, { emit }) {
    const store = useStore();

    store.dispatch("fetchDataTypes");

    const { selectedDataTypeId } = toRefs(props);

    const dataTypes = computed(() => store.getters.dataTypes);

    const { optionsList, selectOption } = useLocationPackagesSelect({
      parentSelectedOptionId: selectedDataTypeId,
      initialOptions: dataTypes,
      onOptionChanged(option: ISelectOption) {
        emit("select", option);
      }
    });

    return { optionsList, selectOption };
  }
});
